<template>
    <div>
        <div class="bg">
            <div class="inner clearfix">
                <div class="filters-placeholder">
                    <div class="filter-placeholder form-group" v-for="(filter) in filters">
                        <label v-if="!filter.type.startsWith('hidden') && !filter.type.startsWith('json')">
                            {{ t(filter.displayName) }}
                        </label>
                        <div v-if="['string'].includes(filter.type)">
                            <textarea type="text" v-model="filter.value" class="controls form-control input-text-area"
                                      @input="filterChange(filter.name, filter.value, filter)"></textarea>
                        </div>
                        <select v-if="['int'].includes(filter.type)" v-model="filter.value" class="controls form-control" @change="filterChange(filter.name, filter.value, filter)">
                            <option :value="null">{{ t('Select') }}</option>
                            <option v-for="model in filter.availableValue"
                                    :value="model.id"
                            >{{ model.name }}</option>
                        </select>
                        <template v-if="['int[]', 'string[]'].includes(filter.type)">
                            <multiselect v-if="filter.group"
                                :max="filter.max"
                                :placeholder="filter.dynamicSearch ? t('Type to search') : t('Select')"
                                :options="filter.availableValue"
                                :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :loading="filterLoading[filter.name]"
                                track-by="id"
                                label="name"
                                :internalSearch="false"
                                group-values="rows"
                                group-label="name"
                                :group-select="true"
                                v-model="filter.value"
                                :custom-label="labelOption"
                                @input="filterChange(filter.name, filter.value, filter)"
                                @open="filterOpen(filter.name, filter.value, filter, filters)"
                                @search-change="searchChange($event, filters, filter)"
                            ><div slot="noOptions">{{ t('List is empty') }}</div>
                            </multiselect>
                            <multiselect v-else
                                :max="filter.max"
                                :placeholder="filter.dynamicSearch ? t('Type to search') : t('Select')"
                                :options="filter.availableValue"
                                :multiple="filter.multiple"
                                :close-on-select="!filter.multiple"
                                :clear-on-select="false"
                                :loading="filterLoading[filter.name]"
                                track-by="id"
                                label="name"
                                v-model="filter.value"
                                :custom-label="labelOption"
                                @input="singleSelectFilterChange(filter.name, filter.value, filter)"
                                @open="filterOpen(filter.name, filter.value, filter, filters)"
                                @search-change="searchChange($event, filters, filter)"
                            ><div slot="noOptions">{{ t('List is empty') }}</div>
                            </multiselect>
                        </template>
                        <div v-if="['range'].includes(filter.type)" class="form-inline">
                            <input type="number" :step="100" :min="filter.min" v-model="filter.value[0]" @change="filterChange(filter.name, filter.value, filter)" class="controls form-control price-range-input">
                            <input type="number" :step="100" :max="filter.max" v-model="filter.value[1]" @change="filterChange(filter.name, filter.value, filter)" class="controls form-control price-range-input">
                        </div>
                        <div v-if="['boolean'].includes(filter.type)" class="form-inline">
                            <input type="checkbox" v-model="filter.value" class="form-control boolean-filter" @change="filterChange(filter.name, filter.value, filter)">
                        </div>
                        <div v-if="['daterange'].includes(filter.type)" class="form-inline">
                            <dateRange-picker-pl style="width: 100%; min-width: 100%;" @update="dateRangeFilterChange(filter.name, filter.value, filter)" v-model="filter.value" :min-date="filter.minDate" :max-date="filter.maxDate">
                                <div slot="input" slot-scope="picker" v-if="filter.value && filter.value.startDate && filter.value.endDate">
                                    {{ filter.value.startDate | customDate }} - {{ filter.value.endDate | customDate }}
                                </div>
                                <div slot="input" slot-scope="picker" v-else>{{ t('Select dates') }}</div>
                            </dateRange-picker-pl>
                        </div>
                        <div v-if="['date'].includes(filter.type)" class="form-inline">
                            <datepicker
                                v-model="filter.value"
                                :calendar-button="true"
                                :language = "lang.current()"
                                clear-button-icon="glyphicon glyphicon-remove"
                                calendar-button-icon="glyphicon glyphicon-time"
                                :format="dateFilterFormat()"
                                @input="dateFilterChange(filter.name, filter.value, filter)"
                                class="controls datepicker-placeholder">
                            </datepicker>
                        </div>
                        <div v-if="['text'].includes(filter.type)" class="form-inline">
                            <textarea
                                class="textarea"
                                v-model="filter.value">
                                @change="filterChange(filter.name, filter.value, filter)"
                            </textarea>
                        </div>
                        <template v-if="filter.type.startsWith('hidden') || filter.type.startsWith('json')">
                            <input type="hidden" v-model="filter.value">
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ValueChecker from "../services/ValueChecker.js";
    import lang from '../services/lang';
    import DataTableDefaultFilter from './DataTableDefaultFilter';
    import Multiselect from '../components/Multiselect';
    import DateRangePickerPl from "./DateRangePickerPl";
    import Datepicker from 'vuejs-datepicker';
    import {DATE_RANGE_FILTER_FORMAT, DATE_FILTER_FORMAT, FILTER_DATE_FORMAT} from "../const";
    const moment = require('moment');
    const lodash = require('lodash');

    export default {
        components: {DataTableDefaultFilter, Multiselect, DateRangePickerPl, Datepicker},
        props: {
            componentIndex: {
                Type: String,
            },
            filters: {
                required: true,
            },
            moduleConfig: {
                Type: Object,
            },
            routeName: {
                Type: String,
                require: true,
            },
        },
        data()
        {
            return {
                events: [],
                filterLoading: {},
                filterState: {},
                interval: null,
                moduleIndex: null,
                searchInterval: null,
                lang: lang
            }
        },
        mounted() {
            this.mountEvents();
        },
        beforeUpdate() {
            this.$prepareFiltersData(this.filters);
        },
        methods: {
            asyncFind(filters, filter, data = {}) {
                let action = this.findActionByName('loadAction', filter);

                if (!action) {
                    let url = this.routeName + '/load-filter-' + this.componentIndex
                    let method = 'get';
                    filter['actions'] = [];
                    filter.actions.push({
                        name: 'loadAction',
                        url: url,
                        method: method
                    })
                }

                data.filterName = filter.name;

                this.getDataFilter(filter, filters, data);
            },
            dateRangeFilterChange(filterName, filterValue, filter) {
                if (filterValue.startDate) {
                    filterValue.startDate = moment(filterValue.startDate).format(FILTER_DATE_FORMAT);
                }
                if (filterValue.endDate) {
                    filterValue.endDate = moment(filterValue.endDate).format(FILTER_DATE_FORMAT);
                }
                filter.value = filterValue;
                this.filterChange(filterName, filterValue, filter);
            },
            dateFilterChange(filterName, filterValue, filter) {
                if (filterValue) {
                    filterValue = moment(filterValue).format(FILTER_DATE_FORMAT);
                }

                filter.value = filterValue;
                this.filterChange(filterName, filterValue, filter);
            },
            filterChange(filterName, filterValue, filter) {
                let _this = this;
                clearInterval(_this.interval);

                this.loadDependsFilters(this.filters, filterName);

                this.interval = setTimeout(() => {
                    this.emitEventChange(filterName, filterValue, filter, this.filters);
                }, 2000);
            },
            emitEventChange(filterName, filterValue, filter, filters) {
                let params = {};
                (filters || []).forEach(v => {
                    if (v.name === 'attrValues') {return;}
                    params[v.name] = null;
                });

                this.$buildFilters(filters, params);
                this.$root.$emit(`${this.moduleIndex}-ToggleFilterPanel:filter-change`, filterName, filterValue, filter, filters, params);
            },
            filterOpen(filterName, filterValue, filter, filters) {
                this.getDataFilter(filter, filters, {'filterName': filterName});
            },
            getDataFilter(filter, filters, params = {}, value = null) {
                let action = this.findActionByName('loadAction', filter);
                let filterName = filter.name;
                let url = '';
                let method = '';
                this.$buildFilters(filters, params);
                delete params[filterName];

                if (!action && !filter.copyAvailableValue) {
                    filter.copyAvailableValue = filter.availableValue;
                }

                if (!action || lodash.isEqual(this.filterState[filter.name], params)) {
                    return;
                } else {
                    url = action.url;
                    method = action.method;
                }

                this.filterState[filterName] = Object.assign({}, params);
                this.$set(this.filterLoading, filterName, true);

                if ("GET" === method.toUpperCase()) {
                    params = {params: params};
                }

                this.$http[method](url, params).then(response => {
                    let data = response.body.data;

                    if ('filterAvailableValue' in filter && filter['filterAvailableValue'].length > 0) {
                        this.filterAvailableValue(data, filter['filterAvailableValue']);
                    }
                    filter.availableValue = data;
                    //make copy for externalSearch
                    filter.copyAvailableValue = data;

                    if (value) {
                        this.$setValue(filter, value);
                    }

                    this.$set(this.filterLoading, filterName, false);
                });
            },
            findActionByName(name, filter) {
                return (filter.actions || []).find(v => {
                    return v.name === name;
                });
            },
            searchChange(searchQuery, filters, filter) {
                if (filter.group) {
                    let query = searchQuery.toLowerCase();
                    filter.availableValue = filter.copyAvailableValue
                        .map(group => ({
                            ...group,
                            rows: group.rows.filter(item =>
                                item.name.toLowerCase().includes(query) || group.name.toLowerCase().includes(query)
                            )
                        }))
                        .filter(group =>
                            group.name.toLowerCase().includes(query) || group.rows.length
                        )
                    ;

                    return;
                }

                if (!filter.dynamicSearch) {
                    return;
                }

                if ('' === searchQuery.trim()) {
                    filter.availableValue = [];

                    return;
                }

                let _this = this;
                this.$set(this.filterLoading, filter.name, true);
                clearInterval(_this.searchInterval);

                _this.searchInterval = setTimeout(() => {
                    _this.asyncFind(filters, filter, {'query': searchQuery});
                }, 2000);
            },
            dateFilterFormat()
            {
                return DATE_FILTER_FORMAT;
            },
            formatDate(date)
            {
                return moment(date).format();
            },
            loadDependsFilters(filters, filterName) {
                filters.forEach(f => {
                    if (!f.dependsOn) {
                        return;
                    }
                    f.dependsOn.forEach(v => {
                        if (filterName === v) {
                            let selFilter = this.$getFilterByName(filters, f.name)
                            this.asyncFind(filters, selFilter);
                        }
                    });
                });
            },
            mountEvents() {
                let eventManagerService = this.$root.getEventManager();
                this.$root.$once('CustomModule:ready', (customModuleEventName, moduleIndex) => {
                    this.moduleIndex = moduleIndex;
                    this.events.push(customModuleEventName);
                    this.events.push(`${this.moduleIndex}-ToggleFilterPanel:filter-change`);
                    eventManagerService.bindEvents(this.defaultBindEvents(`${this.moduleIndex}-ToggleFilterPanel`), this);

                    this.$root.$on(customModuleEventName + ':componentsReady', (moduleConfig, state) => {
                        if (this.setValueAndDataFilterFromQueryString(state.query, this.filters)) {
                            this.interval = setTimeout(() => {
                                this.setDefaultValue(this.filters);
                            }, 1000);
                        } else {
                            this.setDefaultValue(this.filters);
                        }
                    });
                    this.events.push(customModuleEventName + ':componentsReady');
                });
                this.events.push('CustomModule:ready');
            },
            defaultBindEvents(componentIndex) {
                return [{
                    name: 'setState',
                    componentIndex: componentIndex,
                }];
            },
            setDefaultValue(filters) {
                this.emitEventChange('', null, {}, filters);
            },
            labelOption(option) {
                if (option.name) {
                    return `${option.name}`;
                }
                return `${option.value}`;
            },
            singleSelectFilterChange(filterName, filterValue, filter) {
                if (filterValue !== null && filterValue.constructor.toString().indexOf('Array') === -1) {
                    filterValue = [filterValue];
                    filter.value = filterValue;
                }
                this.filterChange(filterName, filterValue, filter);
            },
            setState(data) {
                this.filters.forEach(f => {
                    let element = data.find(d => {
                        return d.name === f.name;
                    });

                    if (ValueChecker.isUndefined(element) || ValueChecker.isUndefined(element.value)) {
                        return;
                    }

                    f.value = element.value;
                });
                this.setDefaultValue(this.filters);
            },
            unmountEvents() {
                let eventManagerService = this.$root.getEventManager();
                eventManagerService.unbindEvents(this.defaultBindEvents());

                this.events.forEach(e => {
                    this.eventBus.$off(e);
                });
            },
            filterAvailableValue(data, availableValue = []) {
                data.forEach((v, index) => {
                    if ('rows' in v) {
                        this.filterAvailableValue(v.rows, availableValue);

                        if (v.rows.length === 0) {
                            data.splice(index, 1);
                            this.filterAvailableValue(data, availableValue);
                            return true;
                        }

                    } else {
                        if (availableValue.includes(v.id)) {
                            return;
                        }

                        data.splice(index, 1);

                        this.filterAvailableValue(data, availableValue);
                        return true;
                    }
                });
            },
            setValueAndDataFilterFromQueryString(query, filters) {
                let setTimeout = false;
                Object.entries(query).forEach(entry => {
                    let [key, value] = entry;
                    let keyName = key.replace('[]', '');
                    let searchBy = 'name';
                    let filter = this.$getFilterByName(filters, keyName, searchBy);

                    if (!filter) {
                        return;
                    }

                    if('actions' in filter && filter.actions.length > 0) {
                        this.getDataFilter(filter, filters, {'filterName': filter.name}, value);
                        setTimeout = true;
                    }

                    this.$setValue(filter, value);
                });

                return setTimeout;
            },
        },
        computed: {
        }
    }
</script>

<style lang="sass">
    .price-range-input {
        width: 45%!important;
    }
    .boolean-filter {
        width: 45px!important;
        margin-top: 0!important;
        margin-left: -5px!important;
    }
    label .vue-daterange-picker {
        font-weight: normal;
    }
    .textarea {
        width: 100%;
        min-width: 100%;
        border-color: rgb(222,222,222);
        border-radius: 5px;
    }
    .datepicker-placeholder input {
        min-width: 90%;
        height: 42px;
        border-color: rgb(222,222,222);
        border-style: solid!important;
        border-width: 1px;
        border-radius: 5px;
    }
    .filters-placeholder {
        display: flex;
        flex-wrap: wrap;
    }
    .filter-placeholder {
        flex-basis: 16.666666667%;
        flex-grow: 16.666666667%;
        flex-shrink: 16.666666667%;
    }
    .filter-placeholder {
        padding-right: 10px;
    }
    .filter-label::first-letter {
        text-transform: uppercase;
    }
    .input-text-area {
        resize: none!important;
        overflow: auto;
        border-color: rgb(222,222,222);
        border-radius: 5px;
        max-height: 43px;
    }
</style>



// WEBPACK FOOTER //
// ToggleFilterPanel.vue?c321aab6